import { render, staticRenderFns } from "./blacklist-list.view.vue?vue&type=template&id=c7ed67c0"
import script from "./blacklist-list.view.vue?vue&type=script&lang=ts"
export * from "./blacklist-list.view.vue?vue&type=script&lang=ts"
import style0 from "./blacklist-list.view.vue?vue&type=style&index=0&id=c7ed67c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports